<template>
  <header id="tachi15Header">
    <b-container>
      <b-row>
        <b-col>
          <h1>Tachi.ai 15</h1>
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
#tachi15Header {
  background: url(../assets/mountainous-landscape.jpg);
  background-position: 0% 40%;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
  display: flex;
  align-items: center;
  text-align: center;
  height: 50vh;
}

#tachi15Header h1 {
  color: white;
  font-size: 6rem;
  font-weight: 700;
  letter-spacing: 0.3rem;
  text-shadow: 0.1rem 0.1rem 0.8rem black;
  padding-bottom: 1rem;
  padding-top: 130px;
}

@media (max-width: 768px) {
  #tachi15Header h1 {
    font-size: 4rem;
  }
}
</style>